module.exports = __webpack_public_path__ + "static/media/w4.299921b6.png";